import React from 'react';

/**
 * The loading element is used to add `data-dash-is-loading` attribute
 * on html elements. This is used to customize CSS when a component is
 * loading.
 *
 * See: https://dash.plotly.com/loading-states#check-loading-states-from-components
 */
function LoadingElement(
    // eslint-disable-next-line react/prop-types
    {elementType = 'div', loading_state = {is_loading: false}, ...props},
    ref
) {
    let loading;
    if (window.dash_component_api !== undefined) {
        const ctx = window.dash_component_api.useDashContext();
        loading = ctx?.useLoading?.() ?? loading_state?.is_loading;
    } else {
        loading = loading_state?.is_loading;
    }
    const givenProps = {
        ...props,
        ref,
    };
    if (loading) {
        givenProps['data-dash-is-loading'] = true;
    }

    return React.createElement(elementType, givenProps);
}

export default React.forwardRef(LoadingElement);
